import { render } from "./AppSubmenu.vue?vue&type=template&id=034b4db9"
import script from "./AppSubmenu.vue?vue&type=script&lang=js"
export * from "./AppSubmenu.vue?vue&type=script&lang=js"

import exportComponent from "/run/media/ctis-dev/developer/WorkSpaceFront/sisfrota-ui-refactor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__